import { useAreaData } from './useAreaData.js';
import { useBarData } from './useBarData.js';
import { useDotData } from './useDotData.js';
import { useLineData } from './useLineData.js';
import { useRectData } from './useRectData.js';
import {
  DOT_VARIANT,
  RECT_VARIANT,
  LINE_VARIANT,
  BAR_VARIANT,
  AREA_VARIANT,
} from '../types/xy-chart-internals.js';

type Variants = [
  typeof DOT_VARIANT,
  typeof RECT_VARIANT,
  typeof LINE_VARIANT,
  typeof BAR_VARIANT,
  typeof AREA_VARIANT,
];

export const useShouldShowGrid = () => {
  const shapes = (
    [
      {
        series: useRectData().filteredSeriesWithDatapoints,
        variant: RECT_VARIANT,
      },
      {
        series: useDotData().filteredSeriesWithDatapoints,
        variant: DOT_VARIANT,
      },
      {
        series: useLineData().filteredSeriesWithDatapoints,
        variant: LINE_VARIANT,
      },
      {
        series: useBarData().filteredSeriesWithDatapoints,
        variant: BAR_VARIANT,
      },
      {
        series: useAreaData().filteredSeriesWithDatapoints,
        variant: AREA_VARIANT,
      },
    ] as const
  ).reduce((acc, current) => {
    if (current.series[0]?.data.length) {
      acc.push(current.variant);
    }

    return acc;
  }, [] as Partial<Variants>);

  return {
    shouldShowGrid: () => !!shapes.length && !shapes.includes(RECT_VARIANT),
    shapes,
  };
};
